import BaseButton from "./BaseButton";
import { BaseButtonTypes } from "./types";
type SecondaryButtonProps = Omit<
	BaseButtonTypes,
	| "fontFamily"
	| "fontSize"
	| "shape"
	| "bgColor"
	| "fontColor"
	| "buttonSize"
	| "hoverBackground"
>;

const SecondaryButton: React.FC<SecondaryButtonProps> = (props) => {
	return (
		<BaseButton
			fontFamily="font-omnes-medium"
			fontSize="text-14px"
			shape="rounded-full"
			bgColor="bg-white"
			fontColor="text-primary"
			buttonSize="h-26px"
			hoverBackground="hover:bg-primaryVeryLight"
			borderColor="border-1 border-primary"
			additionalClasses="text-nowrap py-1 px-3 mx-2 max-sm:mx-1"
			{...props}
		/>
	);
};

export default SecondaryButton;
